module.exports = __webpack_public_path__ + "static/bg-header-contact-us-a3e8cc94f141f27212808062170b31d6.jpg";